<template>
  <span class="linkified" v-html="html"></span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { toAnchors } from "@/app/platformSettings/utils/linkify";

const props = defineProps<{ text?: string }>();
const html = computed(() => toAnchors(props.text ?? ""));
</script>

<style scoped>
.linkified {
  white-space: pre-wrap;
  word-break: break-word;
}
.linkified :deep(a) {
  color: var(--ant-color-link, #1677ff);
  text-decoration: underline;
  cursor: pointer;
}
</style>
